import type { GradeProgressApiResponse } from "@ts/interfaces/progress/api/gradeProgressApiInterface";
import { get } from "./httpClient";

export const getGradeProgress = async (
  gradeCode: number
): Promise<GradeProgressApiResponse> => {
  return await get<GradeProgressApiResponse>(
    `/user/grade/${gradeCode}/progress`
  );
};

export const progressApi = {
  getGradeProgress
};
